var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivearrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.24603 7.2637C5.08841 7.43374 5 7.66324 5 7.90239C5 8.14154 5.08841 8.37103 5.24603 8.54107L7.72589 11.2101C7.90983 11.4037 8.14777 11.5 8.38319 11.5C8.6186 11.5 8.85233 11.4037 9.03205 11.2101L11.5043 8.55008C11.6617 8.37992 11.75 8.15047 11.75 7.91139C11.75 7.67231 11.6617 7.44286 11.5043 7.2727C11.4268 7.18882 11.3345 7.12221 11.2327 7.07674C11.1308 7.03128 11.0215 7.00786 10.9111 7.00786C10.8007 7.00786 10.6915 7.03128 10.5896 7.07674C10.4878 7.12221 10.3955 7.18882 10.318 7.2727L8.37897 9.35845L6.43238 7.2637C6.35472 7.18015 6.26232 7.11382 6.16051 7.06856C6.0587 7.0233 5.9495 7 5.8392 7C5.72891 7 5.61971 7.0233 5.5179 7.06856C5.41609 7.11382 5.32369 7.18015 5.24603 7.2637Z",
    fill: "#164B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivearrow);
export default __webpack_public_path__ + "static/media/activearrow.9dda796074fab4d3de7fc6db6d8f8822.svg";
export { ForwardRef as ReactComponent };